import { render, staticRenderFns } from "./PickupConfigurationCard.vue?vue&type=template&id=64dfeb32&"
import script from "./PickupConfigurationCard.vue?vue&type=script&lang=js&"
export * from "./PickupConfigurationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports